import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {
  deletePersonalEventsAPIHelper,
  deleteProfessionalEventsAPIHelper,
  getCompanyEventsAPIHelper,
  getPersonalEventsAPIHelper,
  getProfessionalEventsAPIHelper,
  postPersonalEventsAPIHelper,
  postProfessionalEventsAPIHelper,
  updatePersonalEventsAPIHelper,
  updateProfessionalEventsAPIHelper,
} from '../helpers/calendarAPI';


const initialState = {
  professionalEventsData: [],
  personalEventsData: [],
  companyEventsData:[]
};

export const getProfessionalEvents = createAsyncThunk(
  '/calendar/get-professional-events',
  async (params, thunkAPI) => {
    try {
      const response = await getProfessionalEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const postProfessionalEvents = createAsyncThunk(
  '/calendar/post-professional-events',
  async (payload, thunkAPI) => {
    try {
      const response = await postProfessionalEventsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const updateProfessionalEvents = createAsyncThunk(
  '/calendar/update-professional-events',
  async (payload, thunkAPI) => {
    try {
      const response = await updateProfessionalEventsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const deleteProfessionalEvents = createAsyncThunk(
  '/calendar/delete-professional-events',
  async (id, thunkAPI) => {
    try {
      const response = await deleteProfessionalEventsAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const getPersonalEvents = createAsyncThunk(
  '/calendar/get-personal-events',
  async (params, thunkAPI) => {
    try {
      const response = await getPersonalEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const postPersonalEvents = createAsyncThunk(
  '/calendar/post-personal-events',
  async (payload, thunkAPI) => {
    try {
      const response = await postPersonalEventsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const updatePersonalEvents = createAsyncThunk(
  '/calendar/update-personal-events',
  async (payload, thunkAPI) => {
    try {
      const response = await updatePersonalEventsAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const deletePersonalEvents = createAsyncThunk(
  '/calendar/delete-personal-events',
  async (id, thunkAPI) => {
    try {
      const response = await deletePersonalEventsAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const getCompanyEvents = createAsyncThunk(
  '/calendar/get-getCompany-events',
  async (params, thunkAPI) => {
    try {
      const response = await getCompanyEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProfessionalEvents.fulfilled, (state, action) => {
        state.professionalEventsData = action.payload?.data;
        console.log('action professional events fulfilled');
      })
      .addCase(getProfessionalEvents.rejected, (state, action) => {
        console.error(
          'action professional events rejected:',
          action.error.message,
        );
      })
      .addCase(postProfessionalEvents.fulfilled, (state, action) => {
        console.log('action post professional events fulfilled');
      })
      .addCase(postProfessionalEvents.rejected, (state, action) => {
        console.error(
          'action post professional events rejected:',
          action.error.message,
        );
      })
      .addCase(updateProfessionalEvents.fulfilled, (state, action) => {
        console.log('action update professional events fulfilled');
      })
      .addCase(updateProfessionalEvents.rejected, (state, action) => {
        console.error(
          'action update professional events rejected:',
          action.error.message,
        );
      })
      .addCase(deleteProfessionalEvents.fulfilled, (state, action) => {
        console.log('action delete professional events fulfilled');
      })
      .addCase(deleteProfessionalEvents.rejected, (state, action) => {
        console.error(
          'action delete professional events rejected:',
          action.error.message,
        );
      })
      .addCase(getPersonalEvents.fulfilled, (state, action) => {
        state.personalEventsData = action.payload.data;
        console.log('action Personal events fulfilled', action.payload.data);
      })
      .addCase(getPersonalEvents.rejected, (state, action) => {
        console.error('action Personal events rejected:', action.error.message);
      })
      .addCase(postPersonalEvents.fulfilled, (state, action) => {
        console.log('action post Personal events fulfilled');
      })
      .addCase(postPersonalEvents.rejected, (state, action) => {
        console.error(
          'action post Personal events rejected:',
          action.error.message,
        );
      })
      .addCase(updatePersonalEvents.fulfilled, (state, action) => {
        console.log('action update Personal events fulfilled');
      })
      .addCase(updatePersonalEvents.rejected, (state, action) => {
        console.error(
          'action update Personal events rejected:',
          action.error.message,
        );
      })
      .addCase(deletePersonalEvents.fulfilled, (state, action) => {
        console.log('action delete Personal events fulfilled');
      })
      .addCase(deletePersonalEvents.rejected, (state, action) => {
        console.error(
          'action delete Personal events rejected:',
          action.error.message,
        );
      })
      .addCase(getCompanyEvents.fulfilled, (state, action) => {
        state.companyEventsData = action.payload.events;
        console.log('action company events fulfilled');
      })
      .addCase(getCompanyEvents.rejected, (state, action) => {
        console.error(
          'action company events rejected:',
          action.error.message,
        );
      });
  },
});

export const {} = calendarSlice.actions;
export default calendarSlice.reducer;
